var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBasicGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_75054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.96701 1.2417C4.17941 1.2417 1.91962 3.5015 1.91962 6.28909C1.91962 9.07669 4.17941 11.3365 6.96701 11.3365C9.75461 11.3365 12.0144 9.07669 12.0144 6.28909C12.0144 3.50149 9.75461 1.2417 6.96701 1.2417Z",
    stroke: "#91A63E",
    strokeWidth: 0.807583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96688 8.30804L8.98584 6.28909L6.96688 4.27013",
    stroke: "#91A63E",
    strokeWidth: 0.807583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94793 6.28906L8.98584 6.28906",
    stroke: "#91A63E",
    strokeWidth: 0.807583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_75054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1137,
    height: 12.1137,
    fill: "white",
    transform: "translate(13.0237 12.3459) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBasicGreen);
export default __webpack_public_path__ + "static/media/arrow-basic-green.b0cf804e678c855c3551a76e7040d62e.svg";
export { ForwardRef as ReactComponent };